var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "com-Breadcrumb", staticStyle: { padding: "0 20px" } },
        [
          _c(
            "el-breadcrumb",
            { attrs: { separator: ">" } },
            [
              _c("el-breadcrumb-item", [
                _c(
                  "a",
                  {
                    on: {
                      click: function($event) {
                        return _vm.gback()
                      }
                    }
                  },
                  [_vm._v("模板管理")]
                )
              ]),
              _c("el-breadcrumb-item", [_vm._v("新增模板")])
            ],
            1
          ),
          _c(
            "a",
            {
              staticClass: "r-btn",
              on: {
                click: function($event) {
                  return _vm.gback()
                }
              }
            },
            [_vm._v("返回上一步")]
          )
        ],
        1
      ),
      _c("el-container", { staticClass: "general" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loadingTpl,
                expression: "loadingTpl"
              }
            ],
            staticClass: "main"
          },
          [
            _c("iframe", {
              ref: "tipEditorRef2",
              staticStyle: { width: "100%", height: "calc(100vh - 100px)" },
              attrs: { src: _vm.editorUrl, frameborder: "0" }
            })
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bd7d3d06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd7d3d06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/authEdit/variableEditor.vue
// module id = 0T+a
// module chunks = 189